var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleAds = function SvgGoogleAds(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b83879c0-b2ee-490b-a970-0dfed3c716b6",
    "data-name": "Layer 1",
    viewBox: "0 0 115.3 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ba6b4391-f43d-4caf-8f44-ade79f84e053",
    transform: "translate(-7.6 -8.9)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.4,
    y: 8.9,
    width: 44.2,
    height: 55.15,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#ba6b4391-f43d-4caf-8f44-ade79f84e053)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,14a6.7,6.7,0,0,1,1.9-3,7.3,7.3,0,0,1,11.5,1.7l5.4,9.5,9.1,15.9a7.3,7.3,0,1,1-12.7,7l-8-13.9c-.1-.1-.1-.2-.2-.2a4.7,4.7,0,0,1-.6-.9L23,19.9a6.6,6.6,0,0,1-.9-3.9,4.5,4.5,0,0,1,.4-2",
    transform: "translate(-7.6 -8.9)",
    style: {
      fill: "#3c8bd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,14a10.8,10.8,0,0,0-.3,1.9,7.2,7.2,0,0,0,1,4.1L29,30.1a4.1,4.1,0,0,1,.5.9l-3.2,5.4-4.4,7.7c-.1,0-.1,0-.1-.1v-.4a6.8,6.8,0,0,0-1.7-7A6.5,6.5,0,0,0,16,34.5a7,7,0,0,0-5.7,1.6c-.3.2-.4.5-.8.7H9.4l2.5-4.4L22.4,14.2V14",
    transform: "translate(-7.6 -8.9)",
    style: {
      fill: "#fabc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4,36.8l1.1-.9a7.2,7.2,0,0,1,11.6,4.4,8.2,8.2,0,0,1-.3,3.8v.3a5.6,5.6,0,0,0-.5.8,7.1,7.1,0,0,1-6.9,3.7,7.2,7.2,0,0,1-6.7-6.3,7,7,0,0,1,1-4.7,4.1,4.1,0,0,1,.5-.9c.1-.1.1-.2.2-.2",
    transform: "translate(-7.6 -8.9)",
    style: {
      fill: "#34a852"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4,36.8s0,.2-.1.2,0-.2.1-.3h0",
    transform: "translate(-7.6 -8.9)",
    style: {
      fill: "#fabc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8,44.4c-.1-.2,0-.3,0-.3h.1v.3",
    transform: "translate(-7.6 -8.9)",
    style: {
      fill: "#e1c025"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.5,8.9a9.3,9.3,0,0,0-9.4,9.2,9.3,9.3,0,0,0,9.4,9.2A8.6,8.6,0,0,0,66,24.7a8.5,8.5,0,0,0,2.1-5.8,7.6,7.6,0,0,0-.1-1.6H59.5v2.5h6.1a5.3,5.3,0,0,1-1.4,3.1,6.3,6.3,0,0,1-4.7,1.9,6.7,6.7,0,0,1,0-13.3,6.2,6.2,0,0,1,4.6,1.8l1.7-1.8A8.9,8.9,0,0,0,59.5,8.9Zm15.4,6.6a5.9,5.9,0,0,0-5.9,6,5.9,5.9,0,1,0,11.8,0,5.9,5.9,0,0,0-5.9-6m0,9.6a3.4,3.4,0,0,1-3.3-3.6,3.4,3.4,0,0,1,3.3-3.6,3.3,3.3,0,0,1,3.3,3.6,3.4,3.4,0,0,1-3.3,3.6m12.8-9.6a5.8,5.8,0,0,0-5.9,6,5.9,5.9,0,0,0,5.9,6,5.9,5.9,0,0,0,5.9-6,5.8,5.8,0,0,0-5.9-6m0,9.6a3.4,3.4,0,0,1-3.3-3.6,3.4,3.4,0,0,1,3.3-3.6A3.3,3.3,0,0,1,91,21.5a3.4,3.4,0,0,1-3.3,3.6m12.8-9.6a5.9,5.9,0,0,0-5.7,5.9,5.8,5.8,0,0,0,5.7,5.9,3.7,3.7,0,0,0,3-1.3h.1v.8c0,2.3-1.1,3.5-3.1,3.5a3.2,3.2,0,0,1-2.9-2l-2.3.9a5.4,5.4,0,0,0,5.2,3.5c3,0,5.6-1.8,5.6-6.2V15.9h-2.5v1h-.1a3.5,3.5,0,0,0-3-1.4m.2,9.5a3.4,3.4,0,0,1-3.3-3.6,3.5,3.5,0,0,1,3.3-3.6,3.3,3.3,0,0,1,3.1,3.6c0,2.1-1.3,3.6-3.1,3.6M108,9.6h2.6V27.2H108V9.6Zm9.5,5.9c-3.1,0-5.6,2.4-5.6,6a5.9,5.9,0,0,0,5.9,6,5.8,5.8,0,0,0,5-2.7l-2.1-1.3a3.2,3.2,0,0,1-2.9,1.6,3,3,0,0,1-2.9-1.8l8-3.3-.2-.7a5.7,5.7,0,0,0-5.2-3.8m-3.1,5.8a3.4,3.4,0,0,1,3.2-3.5,2.3,2.3,0,0,1,2.2,1.3l-5.4,2.2Z",
    transform: "translate(-7.6 -8.9)",
    style: {
      fill: "#757575"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2,48.2l6-15.9h2.3l6,15.9H79.2l-1.5-4.3H71l-1.5,4.3ZM71.7,42H77l-2.6-7.2h-.1Zm11.9,4.9a5.9,5.9,0,0,1-1.5-4.1,6.4,6.4,0,0,1,1.5-4.2A4.7,4.7,0,0,1,87.3,37a3.6,3.6,0,0,1,2.1.5A3.4,3.4,0,0,1,91,38.8h.1V32.3h2V48.2H91.1V46.7H91a4.4,4.4,0,0,1-1.6,1.4,5,5,0,0,1-2.1.5,4.8,4.8,0,0,1-3.7-1.7M90,45.6a3.9,3.9,0,0,0,1-2.8A3.7,3.7,0,0,0,90,40a2.8,2.8,0,0,0-2.4-1.1A3.1,3.1,0,0,0,85.1,40a3.7,3.7,0,0,0-1,2.8,3.9,3.9,0,0,0,1,2.8,3.4,3.4,0,0,0,2.5,1.1A2.8,2.8,0,0,0,90,45.6m12.5,2a5.5,5.5,0,0,1-3.2,1,5,5,0,0,1-2.9-.9,4.4,4.4,0,0,1-1.7-2.3l1.8-.7a2.8,2.8,0,0,0,1.1,1.5,2.7,2.7,0,0,0,1.7.6,4.3,4.3,0,0,0,1.7-.4,1.4,1.4,0,0,0,.6-1c0-.7-.5-1.3-1.6-1.6l-1.9-.4C96,42.8,95,41.8,95,40.3a2.9,2.9,0,0,1,1.2-2.4,5.2,5.2,0,0,1,3.1-.9,4.8,4.8,0,0,1,2.6.6,4.4,4.4,0,0,1,1.7,1.9l-1.9.8a2.1,2.1,0,0,0-1-1.1,2.7,2.7,0,0,0-1.6-.4,2.3,2.3,0,0,0-1.4.4,1.2,1.2,0,0,0-.6,1c0,.6.5,1.1,1.7,1.3l1.7.4c2.1.5,3.2,1.6,3.2,3.3a3.1,3.1,0,0,1-1.2,2.4",
    transform: "translate(-7.6 -8.9)",
    style: {
      fill: "#757575"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleAds, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-ads.429d3139.svg";
export { ForwardRef as ReactComponent };